const FilmRoomQuery = require('./FilmRoomQuery');

// This is a util function and alternative method
// for generating urls besides direct FilmRoomQuery usage
const getFilmRoomUrl = ({
  batterId,
  pitcherId,
  battingTeamId,
  pitchingTeamId,
  hitResult,
  season,
  gamePk,
  startDate,
  endDate,
  gameType,
  orderDir,
  orderBy
}) => {
  const query = new FilmRoomQuery();
  query
    .setBatterId(batterId)
    .setBattingTeamId(battingTeamId)
    .setPitcherId(pitcherId)
    .setPitchingTeamId(pitchingTeamId)
    .setHitResult(hitResult)
    .setGameType(gameType)
    .setSeason(season)
    .setGamePk(gamePk)
    .setDate(startDate, endDate)
    .setOrderBy(orderBy)
    .setOrderDir(orderDir);
  return query.query;
};

module.exports = {
  getFilmRoomUrl,
  FilmRoomQuery
};
